import Meta from './Models/Meta'

Vue.prototype.$models.$meta = new Vue(Meta)

Vue.component('resource-metable', () => import(/* webpackChunkName: "resource-metable" */ '@modulesPages/Meta/Resources/assets/js/Components/ResourceMetable'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Meta\\Entities\\Meta': 'Meta',
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Meta\\Entities\\Meta': 'metas',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'metas': 'Modules\\Meta\\Entities\\Meta',
	}	
}